export const bezirke = {
	"01": "Mitte",
	"02": "Friedrichshain-Kreuzberg",
	"03": "Pankow",
	"04": "Charlottenburg-Wilmersdorf",
	"05": "Spandau",
	"06": "Steglitz-Zehlendorf",
	"07": "Tempelhof-Schöneberg",
	"08": "Neukölln",
	"09": "Treptow-Köpenick",
	10: "Marzahn-Hellersdorf",
	11: "Lichtenberg",
	12: "Reinickendorf",
};

export const markerData = [{ n: "fernsehturm", lat: 52.52084869043665, lon: 13.409393064444167 }];

export const baseOpacity = 0.9;
export const baseOpacityLuftbilder = 0.4;
